"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const validator = require("validator");
const react_redux_1 = require("react-redux");
const react_router_redux_1 = require("react-router-redux");
const LandingActions_1 = require("../LandingActions");
const utils_1 = require("../../utils");
const LandingStore_1 = require("../LandingStore");
const util_1 = require("util");
const AuthenticationActions_1 = require("../../authentication/AuthenticationActions");
const constants_1 = require("../../constants");
const react_bootstrap_1 = require("react-bootstrap");
function mapDispatchToProps(dispatch) {
    return {
        openModal: modal => dispatch(LandingActions_1.openModal(modal)),
        register: payload => dispatch(AuthenticationActions_1.register(payload)),
        dispatch
    };
}
function mapStateToProps(state = constants_1.INITIAL_STATE) {
    return {
        registerProgress: state.landingPage.registerProgress,
        registerErrors: state.landingPage.registerErrors
    };
}
class RegisterComponent extends React.Component {
    constructor(props) {
        super(props);
        this.name = "";
        this.email = "";
        this.password = "";
        this.register = this.register.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.state = {
            state: constants_1.ProgressState.None,
            shouldUpdate: true
        };
    }
    componentDidMount() {
        document.body.scrollTop = 0;
        $('#registerItem').addClass('active-item');
        $('#homeItem').removeClass('active-item');
        $('#contactItem').removeClass('active-item');
    }
    componentWillUnmount() {
        $('#homeItem').addClass('active-item');
        $('#registerItem').removeClass('active-item');
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.registerProgress === constants_1.ProgressState.Success) {
            this.props.dispatch(react_router_redux_1.push(constants_1.ROUTES.Application.Dashboard(this.props.params.orgRoutePrefix)));
        }
    }
    register() {
        if (this.isValid()) {
            this.setState({ shouldUpdate: true });
            this.props.register({
                name: this.name,
                email: this.email,
                password: this.password
            });
        }
    }
    handleKeyPress(target) {
        if (target.charCode == 13) {
            switch (target.target.name) {
                case "name":
                    $(".panel-body #email").focus();
                    break;
                case "email":
                    $("#password").focus();
                    break;
                case "password":
                    this.register();
                    break;
            }
        }
    }
    componentDidUpdate() {
        if (!util_1.isNullOrUndefined(this.props.registerErrors)) {
            this.props.registerErrors.forEach(err => {
                if (err.reason == "WRONG_PASSWORD_LENGTH" && err.param == "password") {
                    this.setState({
                        password: {
                            state: constants_1.ProgressState.Failed,
                            errorMessage: "Wrong password length."
                        }, shouldUpdate: false
                    });
                }
                if (err.reason == "DUPLICATE" && err.param == "email") {
                    this.setState({
                        email: {
                            state: constants_1.ProgressState.Failed,
                            errorMessage: "This email address is already in use."
                        }, shouldUpdate: false
                    });
                }
                if (err.reason == "INCORRECT_EMAIL_ADDRESS" && err.param == "email") {
                    this.setState({
                        email: {
                            state: constants_1.ProgressState.Failed,
                            errorMessage: "Incorrect email address."
                        }, shouldUpdate: false
                    });
                }
                if (err.reason == "WRONG_FORMAT" && err.param == "email") {
                    this.setState({
                        email: {
                            state: constants_1.ProgressState.Failed,
                            errorMessage: "Wrong email format."
                        }, shouldUpdate: false
                    });
                }
            });
        }
    }
    shouldComponentUpdate() {
        return this.state.shouldUpdate;
    }
    render() {
        const registerProgress = this.props.registerProgress || constants_1.ProgressState.None;
        return React.createElement(react_bootstrap_1.Modal, { show: true, onHide: () => {}, className: "landing-modal" }, React.createElement(react_bootstrap_1.Modal.Body, { className: "landing-modal-body" }, React.createElement(react_bootstrap_1.Panel, { className: "login-panel" }, React.createElement("div", { className: "modal-close" }, React.createElement("a", { href: "javascript:void(0)", onClick: () => {
                this.props.openModal(LandingStore_1.LandingModal.Closed);
            } }, "Close")), React.createElement("div", { className: "userpic" }, React.createElement("img", { src: "../img/default_profile.png", alt: "" })), React.createElement("div", { className: "panel-body" }, React.createElement("h2", { className: "text-center" }, "Register with us"), React.createElement(react_bootstrap_1.FormGroup, Object.assign({ controlId: "name" }, utils_1.FormUtils.formGroupAttributes(this.state.name)), React.createElement(react_bootstrap_1.FormControl, { "data-cy": "name_signup_cy", placeholder: "Name", type: "text", name: "name", onKeyPress: this.handleKeyPress, onChange: event => utils_1.FormUtils.dataChanged(event, this) }), utils_1.FormUtils.showErrorBlock(this.state.name)), React.createElement(react_bootstrap_1.FormGroup, Object.assign({ "data-cy": "email_signup_cy", controlId: "email" }, utils_1.FormUtils.formGroupAttributes(this.state.email)), React.createElement(react_bootstrap_1.FormControl, { placeholder: "Email", name: "email", type: "email", onKeyPress: this.handleKeyPress, onChange: event => utils_1.FormUtils.dataChanged(event, this) }), utils_1.FormUtils.showErrorBlock(this.state.email)), React.createElement(react_bootstrap_1.FormGroup, Object.assign({ "data-cy": "password_signup_cy", controlId: "password" }, utils_1.FormUtils.formGroupAttributes(this.state.password)), React.createElement(react_bootstrap_1.FormControl, { placeholder: "Password", name: "password", type: "password", onKeyPress: this.handleKeyPress, onChange: event => utils_1.FormUtils.dataChanged(event, this) }), utils_1.FormUtils.showErrorBlock(this.state.password)), React.createElement("br", null), React.createElement(react_bootstrap_1.Button, { "data-cy": "signUpButton", className: "modal-button", title: "Register", bsStyle: "primary", onClick: this.register }, "Sign up"), React.createElement("br", null), React.createElement("br", null), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { md: 12, className: "text-center" }, React.createElement("a", { href: "javascript:void(0)", onClick: () => {
                this.props.openModal(LandingStore_1.LandingModal.Login);
            } }, "Already have account? Sign in now!")))))));
    }
    isValid() {
        let valid = true;
        if (validator.isEmpty(this.email)) {
            this.setState({
                email: {
                    state: constants_1.ProgressState.Failed,
                    errorMessage: "Email is required."
                }
            });
        } else if (!validator.isEmail(this.email)) {
            this.setState({
                email: {
                    state: constants_1.ProgressState.Failed,
                    errorMessage: "Not valid email format."
                }
            });
        } else {
            this.setState({
                email: {
                    state: constants_1.ProgressState.Success
                }
            });
        }
        if (validator.isEmpty(this.password)) {
            this.setState({
                password: {
                    state: constants_1.ProgressState.Failed,
                    errorMessage: "Password is required."
                }
            });
        } else {
            this.setState({
                password: {
                    state: constants_1.ProgressState.Success
                }
            });
        }
        if (validator.isEmpty(this.name)) {
            this.setState({
                name: {
                    state: constants_1.ProgressState.Failed,
                    errorMessage: "Name is required."
                }
            });
        } else {
            this.setState({
                name: {
                    state: constants_1.ProgressState.Success
                }
            });
        }
        return valid;
    }
}
const Register = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(RegisterComponent);
exports.default = Register;


//////////////////
// WEBPACK FOOTER
// ./client/src/landing/components/Register.tsx
// module id = 1054
// module chunks = 0 1